// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SocialMediaLinks_wrapper__W2MbX","linkList":"SocialMediaLinks_linkList__kWwFM"};